module.exports = "<div class=\"cropper-img_container\">\n    <img class=\"js-cropper-img-item cropper-img__item\" src=\"{{url}}\" alt=\"\"/>\n</div>\n";